export default "__VITE_ASSET__DYcSUz_2__"